import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatRadioChange, MatSnackBar, MatTableDataSource } from '@angular/material';
import { TagService } from '../../shared/services/tag.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { BusinessHoursTableComponent } from '../business-hours-table/business-hours-table.component';
var EditBusinessHoursComponent = /** @class */ (function () {
    function EditBusinessHoursComponent(_matDialogRef, _tagService, _businessManagerService, snackBar, data) {
        this._matDialogRef = _matDialogRef;
        this._tagService = _tagService;
        this._businessManagerService = _businessManagerService;
        this.snackBar = snackBar;
        this.disableClose = false;
        this.isRadioGroupDisabled = false;
        this.title = '';
        this.selectedHourTag = null;
        this.title = data.title;
        this.business = data.business;
    }
    EditBusinessHoursComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.setSelectedHourTag();
                this.setBusinessHours();
                this.setHoursExceptions();
                this.setHoursTags();
                this._matDialogRef.backdropClick().subscribe(function () { return _this.closeDialog(); });
                return [2 /*return*/];
            });
        });
    };
    //#region ngOnInit set up
    EditBusinessHoursComponent.prototype.setHoursTags = function () {
        var _this = this;
        this._tagService.getAllTags().then(function (tags) {
            _this.allTags = tags;
            _this.hoursTags = _this.allTags.filter(_this.isHoursBusinessTag);
        });
    };
    EditBusinessHoursComponent.prototype.setSelectedHourTag = function () {
        var hoursTags = this.business.tags.filter(this.isHoursBusinessTag);
        if (hoursTags.length > 0) {
            this.selectedHourTag = hoursTags.pop();
        }
    };
    EditBusinessHoursComponent.prototype.setBusinessHours = function () {
        this.businessHours = this.business.hours;
    };
    EditBusinessHoursComponent.prototype.setHoursExceptions = function () {
        this.hoursExceptions = this.business.hoursExceptions;
    };
    //#endregion
    EditBusinessHoursComponent.prototype.isHoursBusinessTag = function (element) {
        return (/^Hours::.+/.test(element.tagName));
    };
    EditBusinessHoursComponent.prototype.isDisplayHoursRadioBtnSelected = function (hour) {
        if (!hour) {
            return false;
        }
        else if (this.selectedHourTag === null) {
            return hour.tagName === 'customHours';
        }
        else {
            return hour.tagName === this.selectedHourTag.tagName;
        }
    };
    EditBusinessHoursComponent.prototype.displayHoursRadioBtnChanged = function (radioChange) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newHoursTagSelection_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.diableCloseBtn();
                this.disableRadioGrp();
                if (radioChange.value === 'customHours') { // User selects customHours
                    this.updateRadioBtnTagStatus(this.selectedHourTag, true)
                        .then(function () {
                        _this.selectedHourTag = null;
                        _this.reEnableCloseBtn();
                        _this.reEnableRadioGrp();
                    });
                }
                else {
                    newHoursTagSelection_1 = this.allTags.filter(function (tag) { return tag.tagName.includes(radioChange.value); }).pop();
                    if (!this.selectedHourTag) { // Aka customHours was the previous value
                        this.updateRadioBtnTagStatus(newHoursTagSelection_1, false)
                            .then(function () {
                            _this.setSelectedHourTag();
                            _this.reEnableCloseBtn();
                            _this.reEnableRadioGrp();
                        });
                    }
                    else { // All other cases
                        this.updateRadioBtnTagStatus(this.selectedHourTag, true)
                            .then(function () { return _this.updateRadioBtnTagStatus(newHoursTagSelection_1, false)
                            .then(function () {
                            _this.setSelectedHourTag();
                            _this.reEnableCloseBtn();
                            _this.reEnableRadioGrp();
                        }); });
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    EditBusinessHoursComponent.prototype.updateRadioBtnTagStatus = function (tag, shouldDelete) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, tagId, newBusiness, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        tagId = tag.tagId;
                        if (!shouldDelete) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.deleteTag(tagId, this.business.id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.postTag(tagId, this.business.id)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 6:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    EditBusinessHoursComponent.prototype.updateHoursException = function (hrExceptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, newBusiness, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.diableCloseBtn();
                        ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.business.closedHolidays = hrExceptions;
                        return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 2:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_2;
                    case 4:
                        this.reEnableCloseBtn();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    EditBusinessHoursComponent.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, newBusiness, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.business) return [3 /*break*/, 1];
                        this._matDialogRef.close(true);
                        return [3 /*break*/, 5];
                    case 1:
                        ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 3:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        this.snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    EditBusinessHoursComponent.prototype.closeDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.canDeactivate()) {
                    this.close();
                }
                else {
                    if (confirm('You Have Unsaved Changes. Press Cancel to go back and save changes or Ok to discard changes.')) {
                        this.close();
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    EditBusinessHoursComponent.prototype.disableRadioGrp = function () {
        this.isRadioGroupDisabled = true;
    };
    EditBusinessHoursComponent.prototype.reEnableRadioGrp = function () {
        this.isRadioGroupDisabled = false;
    };
    EditBusinessHoursComponent.prototype.diableCloseBtn = function () {
        this.disableClose = true;
    };
    EditBusinessHoursComponent.prototype.reEnableCloseBtn = function () {
        this.disableClose = false;
    };
    EditBusinessHoursComponent.prototype.canDeactivate = function () {
        return (!this.bHrsTble || !this.bHrsTble.hasUnsavedChanges())
            && this.hoursExceptions === this.business.hoursExceptions;
    };
    return EditBusinessHoursComponent;
}());
export { EditBusinessHoursComponent };
